export default "__VITE_ASSET__D5YR0Q4h__"